import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { pick } from 'lodash';

import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CoreAccountingService } from '../core-accounting.service';

@Injectable({ providedIn: 'root' })
export class DiscountConfigurationService extends CoreAccountingService {

  constructor(
    private http: HttpClient,
  ) {
    super(http, 'discountconfiguration');
    this.headers = this.headers.append('skip-cache', 'true');
  }

  filter(params): Observable<any> {
    this.setHeader(true);
    const url = `${this.base_url}/filter/${localStorage.getItem('tenant')}`;
    return this.http.get<any>(url, {params: params, headers: this.headers}).pipe(
      tap(_ => this.log(`fetched ProductConfigurartion`)),
      catchError(this.handleError<any>(`getProductConfigurartion `))
    );
  }

  toggleStatus(id:any): Observable<any> {
    this.setHeader(true);
    const url = `${this.base_url}/toggleStatus/${id}`;
    return this.http.post<any>(url, {headers: this.headers}).pipe(
      tap(_ => this.log(`fetched ProductConfigurartion`)),
      catchError(this.handleError<any>(`getProductConfigurartion `))
    );
  }

  create(data:any): Observable<any> {
    this.setHeader(true);
    const url = `${this.base_url}/create/${localStorage.getItem('tenant')}`;
    return this.http.post<any>(url, data,{headers: this.headers}).pipe(
      tap(_ => this.log(`fetched ProductConfigurartion`)),
      catchError(this.handleError<any>(`getProductConfigurartion `))
    );
  }

  update(id:number, data:any): Observable<any> {
    this.setHeader(true);
    const url = `${this.base_url}/update/${id}`;
    return this.http.post<any>(url, data,{headers: this.headers}).pipe(
      tap(_ => this.log(`fetched ProductConfigurartion`)),
      catchError(this.handleError<any>(`getProductConfigurartion `))
    );
  }

  deleteConfig(id:number): Observable<any> {
    this.setHeader(true);
    const url = `${this.base_url}/delete/${id}`;
    return this.http.post<any>(url,{headers: this.headers}).pipe(
      tap(_ => this.log(`fetched ProductConfigurartion`)),
      catchError(this.handleError<any>(`getProductConfigurartion `))
    );
  }

  getEligibleDiscount(customerId:number, globalProductId:number): Observable<any> {
    this.setHeader(true);
    let params = {
      customerId: customerId,
      globalProductId: globalProductId
    }
    const url = `${this.base_url}/getEligibleDiscount`;
    return this.http.get<any>(url,{params: params, headers: this.headers}).pipe(
      tap(_ => this.log(`fetched ProductConfigurartion`)),
      catchError(this.handleError<any>(`getProductConfigurartion `))
    );
  }
}
